import React from "react";
import InternalHeader from "~/components/Layout/components/InternalHeader";
import { useLang } from "~/hooks/useLang";
import ListAllAuditDeviceReport from "./components/ListAllAuditDeviceReport";

export default function AuditDeviceReportTable() {
    const { translate } = useLang();
    
    return (
        <>
            <InternalHeader title={`${translate('Audit')}: ${translate('Devices')}`} />
            <ListAllAuditDeviceReport />
        </>
    )
}